import { render, staticRenderFns } from "./RoleH5.vue?vue&type=template&id=ff1475b6"
import script from "./RoleH5.vue?vue&type=script&lang=js"
export * from "./RoleH5.vue?vue&type=script&lang=js"
import style0 from "./RoleH5.vue?vue&type=style&index=0&id=ff1475b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports